export const SEND_EMAIL_START = "sendEmail/START"
export const SEND_EMAIL_SUCCESSFUL = "sendEmail/SUCCESSFUL"
export const SEND_EMAIL_ERROR = "sendEmail/ERROR"

export const RESET_PASSWORD_START = "resetPassword/START"
export const RESET_PASSWORD_SUCCESSFUL = "resetPassword/SUCCESSFUL"
export const RESET_PASSWORD_ERROR = "resetPassword/ERROR"